var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIconPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 36745"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 30",
    cx: 6.83129,
    cy: 6.47069,
    r: 5.96386,
    fill: "#EEEBFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 1",
    d: "M4.92809 4.56629L8.73632 8.37452",
    stroke: "#6C53E8",
    strokeWidth: 0.795181,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 2",
    d: "M8.73707 4.56394L4.92492 8.37609",
    stroke: "#6C53E8",
    strokeWidth: 0.795181,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIconPurple);
export default __webpack_public_path__ + "static/media/close-icon-purple.eed4991143e8545c7ccdd628d99c8bba.svg";
export { ForwardRef as ReactComponent };